import "./Footer.css";

const Footer = () => {
  return (
    <div className="Footer">
    <footer>
      <p>Developed by Team Imp © 2021</p>
    </footer>
    </div>
  );
};
export default Footer;
